import { inView } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import './styles.css';


const MobSplitQuote = ({splitQuote}) => {

    const { ref: upperQuoteRef, inView: upperQuoteInView } = useInView({
        triggerOnce: true,
        rootMargin: "00px 0px 0px 0px",
        threshold: 0,
    });

    const { ref: upperLineRef, inView: upperLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "00px 0px 0px 0px",
        threshold: 0,
    });

    const { ref: lowerLineRef, inView: lowerLineInView } = useInView({
        triggerOnce: true,
        rootMargin: "00px 0px 0px 0px",
        threshold: 0,
    });

    const { ref: lowerQuoteRef, inView: lowerQuoteInView } = useInView({
        triggerOnce: true,
        rootMargin: "00px 0px 0px 0px",
        threshold: 0,
    });

    return(
        <>  
            <div className="mob_split__wrapper" >
            {
                splitQuote &&
                <div 
                    className="mob_split_quote"
                    style={{
                        fontFamily: "var(--font-bold)",
                        fontWeight: "800",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        whiteSpace: "wrap",
                        lineHeight: 1,
                        margin: "40dvh 0 25dvh 0",
                        paddingLeft: "20px",
                        whiteSpace: "nowrap",
                        position: "relative"
                    }}
                >
                    <span style={{
                        overflow: "hidden"
                    }}>
                        <span 
                            className={`hollow-text ${upperQuoteInView ? 'quoteIn' : ''}`}
                                style={{
                                position: "absolute",
                                top: "-60px",
                                left: 0,
                                fontSize: "25vw",
                                opacity: 0
                            }}
                            ref={upperQuoteRef}
                        ><span>“</span></span>
                            <span
                                style={{
                                    display: "inline-block",
                                    transform: "translate3d(0, 100%, 0)",
                                    opacity: 0,
                                    fontSize: splitQuote[0].length >= 17 ? "12.5vw" : splitQuote[0].length > 15 ? "13.5vw" : splitQuote[0].length > 11 ? "16vw" : "21vw",
                                    animation: `${upperLineInView ? 'lineUp 2s 0.16s cubic-bezier(0.16, 1, 0.3, 1) forwards' : ''}`
                                }}
                                ref={upperLineRef}>{splitQuote[0]}</span>
                        </span>
                        <span className="hollow-text" style={{
                            overflow: "hidden",
                            paddingTop: "10px",
                            lineHeight: 0.85,
                            display: "flex",
                        }}>
                            <span 
                                className={`hollow-text`}
                                style={{
                                    position: "absolute",
                                    bottom: "-60px",
                                    right: 0,
                                    fontSize: "25vw",
                                    opacity: 0,
                                    animation: `${upperLineInView ? 'quoteIn 2s 0.75s cubic-bezier(0.16, 1, 0.3, 1) forwards' : ''}`
                                }}
                                ref={lowerQuoteRef}
                            >”</span>
                            <span 
                                ref={lowerLineRef}
                                style={{
                                    display: "inline-block",
                                    transform: "translate3d(0, 100%, 0)",
                                    opacity: 0,
                                    fontSize: splitQuote[1].length > 25 ? "8vw" : splitQuote[1].length >= 19 ? "11.75vw" : (splitQuote[0].length >= 17 || splitQuote[1].length >= 17) ? "12.5vw" : splitQuote[1].length > 25 ? "8vw" : splitQuote[1].length > 20 ? "11vw" : "13vw",
                                    animation: `${upperLineInView ? 'lineUp 2s 0.33s cubic-bezier(0.16, 1, 0.3, 1) forwards' : ''}`
                                }}
                            >{splitQuote[1]}</span>
                        {/* <span
                            style={{
                                display: "inline-block",
                                // transform: "scale(-1, 1)"
                            }}
                        >”</span> */}
                    </span>
                </div>
            }
            </div>
        </>
    )
}

export default MobSplitQuote;